import _ from 'lodash'

export function customizer(objValue: any, srcValue: any) {
  return _.isUndefined(objValue) ? srcValue : objValue
}